// import React from "react";
// import tw from "tailwind-styled-components";
// import Images from "../Images";

// const NotFoundModel = ({msg}) => {
//   return (
//     <Wrapper>
//       <Figure>
//         <img src={Images.NotFound} alt="error image" />
//       </Figure>
//       <Title>{msg ? msg : 'Data Not Found'}</Title>
//     </Wrapper>
//   );
// };

// const Wrapper = tw.div`w-11/12 max-w-3xl mx-auto my-8  flex flex-col  `;
// const Title = tw.h2`text-sm md:text-base text-gray-400 font-normal text-center`;
// const Figure = tw.div`w-40 mx-auto mb-4`;

// export default NotFoundModel;

import React from "react";
import tw from "tailwind-styled-components";
import Images from "../Images";

const NotFoundModel = ({ msg }) => {
  return (
    <Container>
      <Wrapper>
        <Figure>
          <img src={Images.NotFound} alt="Data not found" />
        </Figure>
        <Title>{msg || "Data Not Found"}</Title>
      </Wrapper>
    </Container>
  );
};

export default NotFoundModel;

/* Styled Components */

const Container = tw.div`
  w-full h-full min-h-[300px]
  flex items-center justify-center
`;

const Wrapper = tw.div`
  flex flex-col items-center
  text-center
`;

const Figure = tw.div`
  w-40 mb-4
`;

const Title = tw.h2`
  text-sm md:text-base
  text-gray-400 font-normal
`;
